export const TOTAL = "Total";
export const DUE_TODAY = "Due Today";
